import React from "react";
import { HashLink } from "react-router-hash-link";
import { ArrowRight, Mail, Phone, Smartphone } from "lucide-react";
import Reveal from "../common/Reveal";
import MagneticButton from "../common/MagneticButton";
import DotField from "../hero/DotField";
import { PLAY_STORE_URL } from "../../content/product";

export default function CtaModern() {
  return (
    <section
      className="eb-section"
      style={{
        position: "relative",
        overflow: "hidden",
        background: "radial-gradient(ellipse 90% 70% at 50% 30%, #f4f8ff 0%, #ffffff 65%)",
      }}
    >
      <DotField intensity={0.7} spacingScale={1.15} />

      <div className="container" style={{ position: "relative", zIndex: 1 }}>
        <Reveal>
          <div
            className="eb-card"
            style={{
              padding: "clamp(40px, 5.5vw, 72px) clamp(24px, 4vw, 56px)",
              borderRadius: "var(--radius-lg)",
              textAlign: "center",
              background:
                "linear-gradient(180deg, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0.96) 55%, #ffffff 100%)",
              backdropFilter: "blur(6px)",
            }}
          >
            <h2
              className="eb-section-title"
              style={{ maxWidth: "560px", margin: "0 auto 18px" }}
            >
              Ready to simplify your EMI operations?
            </h2>

            <p
              style={{
                fontSize: "1.02rem",
                color: "var(--text-muted)",
                maxWidth: "480px",
                margin: "0 auto 34px",
                lineHeight: 1.65,
              }}
            >
              Customers, schedules, payments and receipts — brought together in one app.
            </p>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "12px",
                flexWrap: "wrap",
              }}
            >
              <MagneticButton>
                <a
                  href={PLAY_STORE_URL}
                  target="_blank"
                  rel="noreferrer"
                  className="eb-btn eb-btn-primary"
                >
                  <Smartphone size={16} /> Download for Android
                </a>
              </MagneticButton>

              <MagneticButton>
                <HashLink smooth to="#contact" className="eb-btn eb-btn-secondary">
                  Talk to us <ArrowRight size={16} />
                </HashLink>
              </MagneticButton>
            </div>

            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                alignItems: "center",
                gap: "26px",
                marginTop: "40px",
                paddingTop: "26px",
                borderTop: "1px solid var(--border-light)",
                fontSize: "0.86rem",
              }}
            >
              <span style={{ display: "inline-flex", alignItems: "center", gap: "7px" }}>
                <Phone size={14} color="var(--color-primary)" />
                <a
                  href="tel:+919036770772"
                  style={{ color: "var(--text-strong)", textDecoration: "none", fontWeight: 600 }}
                >
                  +91 9036770772
                </a>
              </span>
              <span style={{ display: "inline-flex", alignItems: "center", gap: "7px" }}>
                <Mail size={14} color="var(--color-indigo)" />
                <a
                  href="mailto:support@emibook.in"
                  style={{ color: "var(--text-strong)", textDecoration: "none", fontWeight: 600 }}
                >
                  support@emibook.in
                </a>
              </span>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
